module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "accessStoreInfo",
    attrs: {
      "id": "accessStoreInfo"
    }
  }, [_c('el-row', {
    staticClass: "clearfix",
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_c('el-col', {
    staticClass: "fl",
    attrs: {
      "span": 2
    }
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "type": "warning"
    },
    on: {
      "click": function($event) {
        return _vm.backGo()
      }
    }
  }, [_vm._v("返回")])], 1), _vm._v(" "), _c('el-col', {
    staticClass: "fr",
    attrs: {
      "span": 1
    }
  }, [_c('i', {
    staticClass: "el-icon-refresh",
    staticStyle: {
      "font-size": "25px",
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        return _vm.refresh()
      }
    }
  })])], 1), _vm._v(" "), _c('el-col', {
    staticClass: "fl searthPart no-print"
  }, [_c('el-form', {
    ref: "returnForm",
    attrs: {
      "model": _vm.returnForm,
      "inline": true,
      "id": "test",
      "label-width": "100px",
      "label-position": _vm.labelPosition
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "出入库编号:"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true,
      "value": _vm.returnForm.code
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "iconfont hohofast-copy copyBtn",
    on: {
      "click": function($event) {
        return _vm.handleCopy(_vm.returnForm.code, $event)
      }
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "出入库类型:"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true
    },
    model: {
      value: (_vm.returnForm.type),
      callback: function($$v) {
        _vm.$set(_vm.returnForm, "type", $$v)
      },
      expression: "returnForm.type"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "出入库仓库:"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true
    },
    model: {
      value: (_vm.returnForm.warehouseType),
      callback: function($$v) {
        _vm.$set(_vm.returnForm, "warehouseType", $$v)
      },
      expression: "returnForm.warehouseType"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label-width": "60px",
      "label": "状态:"
    }
  }, [(_vm.returnForm.status == 'YQR') ? _c('el-input', {
    attrs: {
      "disabled": true,
      "value": "已确认"
    }
  }) : (_vm.returnForm.status == 'CG') ? _c('el-input', {
    attrs: {
      "disabled": true,
      "value": "暂存"
    }
  }) : _c('el-input', {
    attrs: {
      "disabled": true,
      "value": "已完成"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label-width": "80px",
      "label": "操作人:"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true
    },
    model: {
      value: (_vm.returnForm.createUser),
      callback: function($$v) {
        _vm.$set(_vm.returnForm, "createUser", $$v)
      },
      expression: "returnForm.createUser"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "提交时间:"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true
    },
    model: {
      value: (_vm.returnForm.createTime),
      callback: function($$v) {
        _vm.$set(_vm.returnForm, "createTime", $$v)
      },
      expression: "returnForm.createTime"
    }
  })], 1), _vm._v(" "), (_vm.returnForm.relatedId !== '' && _vm.returnForm.relatedId !== undefined) ? _c('el-form-item', {
    attrs: {
      "label-width": "80px",
      "label": "供应商:"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true
    },
    model: {
      value: (_vm.returnForm.supplierName),
      callback: function($$v) {
        _vm.$set(_vm.returnForm, "supplierName", $$v)
      },
      expression: "returnForm.supplierName"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "备注信息:"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true
    },
    model: {
      value: (_vm.returnForm.memo),
      callback: function($$v) {
        _vm.$set(_vm.returnForm, "memo", $$v)
      },
      expression: "returnForm.memo"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    staticClass: "fr"
  }, [_c('el-card', {
    staticClass: "box-card fr",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('el-table', {
    attrs: {
      "data": _vm.returnData,
      "border": "",
      "header-cell-style": {
        'text-align': 'center'
      },
      "summary-method": _vm.getSummaries,
      "show-summary": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "align": "center",
      "type": "index",
      "width": "50",
      "label": "序号"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "materialCode",
      "label": "物料编号"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "modelName",
      "label": "型号"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "materialName",
      "label": "物料名称"
    }
  }), _vm._v(" "), (_vm.returnForm.type != '物料出库') ? _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "aogSum",
      "width": "100",
      "label": "到货数量"
    }
  }) : _vm._e(), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "inboundSum",
      "width": "100",
      "label": _vm.returnForm.type == '物料出库' ? '出库数量' : '入库数量'
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "price",
      "width": "100",
      "label": "入库单价"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "shouldInPrice",
      "width": "100",
      "label": "应入价"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "amount",
      "width": "100",
      "label": "合计金额"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "操作"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "text",
            "size": "small"
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              return _vm.showSerialNumber(scope.$index, scope.row)
            }
          }
        }, [_vm._v("查看序列号")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "text",
            "size": "small"
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              return _vm.addPreviewBarCode(scope.$index, scope.row)
            }
          }
        }, [_vm._v("条形码打印预览")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "text",
            "size": "small"
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              return _vm.addBarCode(scope.$index, scope.row)
            }
          }
        }, [_vm._v("补印条形码")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "tableId",
      "data": _vm.returnData,
      "border": "",
      "header-cell-style": {
        'text-align': 'center'
      },
      "summary-method": _vm.getSummaries,
      "show-summary": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "align": "center",
      "type": "index",
      "width": "110",
      "label": "序号"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "width": "110",
      "prop": "materialCode",
      "label": "物料编号"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "width": "110",
      "prop": "modelName",
      "label": "型号"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "width": "110",
      "prop": "materialName",
      "label": "物料名称"
    }
  }), _vm._v(" "), (_vm.returnForm.type != '物料出库') ? _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "aogSum",
      "width": "110",
      "label": "到货数量"
    }
  }) : _vm._e(), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "inboundSum",
      "width": "110",
      "label": _vm.returnForm.type == '物料出库' ? '出库数量' : '入库数量'
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "price",
      "width": "110",
      "label": "入库单价"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "amount",
      "width": "110",
      "label": "合计金额"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticClass: "pagination"
  }, [_c('el-pagination', {
    attrs: {
      "background": "",
      "current-page": _vm.pages.page,
      "page-sizes": [10, 20, 50, 100],
      "page-size": _vm.pages.pageSize,
      "layout": "total, sizes, prev, pager, next",
      "total": _vm.pages.total
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange
    }
  })], 1)])], 1), _vm._v(" "), _c('el-button', {
    staticClass: "fr",
    staticStyle: {
      "margin": "50px 20px 50px 0"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.printTable()
      }
    }
  }, [_vm._v("打印入库记录")]), _vm._v(" "), _c('el-button', {
    staticClass: "fr",
    staticStyle: {
      "margin": "50px 20px 50px 0"
    },
    attrs: {
      "id": "form1",
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.PrintingBarCode()
      }
    }
  }, [_vm._v("全部打印条形码")]), _vm._v(" "), _c('el-button', {
    staticClass: "fr",
    staticStyle: {
      "margin": "50px 20px 50px 0"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.PrintingPreviewRecord()
      }
    }
  }, [_vm._v("全部条形码打印预览")])], 1), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "formTable"
    }
  }, [_c('table', [_c('tr', [_c('th', {
    attrs: {
      "colspan": "8"
    }
  }, [_vm._v("出入库信息")])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("出入库编号:")]), _vm._v(" "), _c('th', [_vm._v("出入库类型:")]), _vm._v(" "), _c('th', [_vm._v("出入库仓库:")]), _vm._v(" "), _c('th', [_vm._v("状态:")]), _vm._v(" "), _c('th', [_vm._v("操作人:")]), _vm._v(" "), _c('th', [_vm._v("提交时间:")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.returnForm.code))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.returnForm.type))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.returnForm.warehouseType))]), _vm._v(" "), _c('td', [_vm._v("已完成")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.returnForm.createUser))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.returnForm.createTime))])]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "colspan": "8"
    }
  }, [_vm._v("关联信息")])]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v("关联采购订单:")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v("备注信息:")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v(_vm._s(_vm.returnForm.relatedId))]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v(_vm._s(_vm.returnForm.memo))])])])]), _vm._v(" "), _c('el-dialog', {
    staticClass: "dialog-content",
    attrs: {
      "visible": _vm.dialogTableVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogTableVisible = $event
      }
    }
  }, [_c('el-row', {
    staticClass: "dialog-code-content",
    attrs: {
      "element-loading-text": "拼命加载中",
      "element-loading-spinner": "el-icon-loading"
    }
  }, _vm._l((_vm.checkCodeList), function(item, index) {
    return (item != '') ? _c('el-col', {
      key: index,
      attrs: {
        "span": 6
      }
    }, [_c('p', [_vm._v(_vm._s(item))])]) : _vm._e()
  }), 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogTableVisible = false
      }
    }
  }, [_vm._v("关闭")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /opt/devenv/allscs-jhh/repair-ui/~/vue-loader/lib/template-compiler?{"id":"data-v-697ecd30","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!/opt/devenv/allscs-jhh/repair-ui/~/vue-loader/lib/selector.js?type=template&index=0!./src/views/storeManageOuter/accessStoreInfo.vue
// module id = 1701
// module chunks = 0